module.exports = __webpack_public_path__ + "static/product-flower-bottom-92c44a721a8f494f1ff478a89cd6463d.png";